/**
 * Calculates performance insights based on performance data
 * @param {Array} data - Array of performance data points with mu values
 * @param {Array} matches - Array of match objects
 * @param {Object} player - Player object with id
 * @returns {Object} Object containing trend, change, streak, and isWinStreak
 */
export const getPerformanceInsights = (data, matches, player) => {
  if (!data || data.length < 2)
    return { trend: 'No Data', change: 0, streak: 0 };

  const recent = data.slice(-5);
  const change = recent[recent.length - 1].mu - recent[0].mu;
  const trend = change > 1 ? 'Improving' : change < -1 ? 'Declining' : 'Stable';

  // Calculate win/loss streak from recent matches
  const playerMatches =
    matches
      ?.filter(
        m => m.winners.includes(player?.id) || m.losers.includes(player?.id)
      )
      .slice(-10) || [];

  let streak = 0;
  let lastWasWin = null;
  for (let i = playerMatches.length - 1; i >= 0; i--) {
    const isWin = playerMatches[i].winners.includes(player?.id);
    if (lastWasWin === null) {
      lastWasWin = isWin;
      streak = 1;
    } else if (lastWasWin === isWin) {
      streak++;
    } else {
      break;
    }
  }

  return { trend, change: change.toFixed(2), streak, isWinStreak: lastWasWin };
};
